
import {catchError,  map, share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as _ from 'underscore';
import { HttpResponseHandlerService } from '../../services/http-response-handler.service';

@Injectable()
export class PaymentAjaxService {

  header;
  sessionout: boolean = false;
  isMaintainance: boolean = false;
  constructor(private http: HttpClient,
    private httpResponseHandlerService:HttpResponseHandlerService
  ) { }

  get(searchParams, url: any): Observable<String> {
    let apiUrl = environment.apiUrl + url;
    return this.http.get(apiUrl, { withCredentials: true, params: searchParams }).pipe(map(res => {
      return this.httpResponseHandlerService.handleHTTPResponse(res);
    }), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }
  post(url, params): Observable<void> {
    this.header = new HttpHeaders({
      "content-type": "application/x-www-form-urlencoded",
      "accept": "application/json, text/plain, */*"
    });
    return this.http.post(environment.apiUrl + url, params, { withCredentials: true, headers: this.header }).pipe(map(res => {
      return this.httpResponseHandlerService.handleHTTPResponse(res);
    }), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }
  paymentIQPost(url, params): Observable<String> {
    return this.http.post(environment.paymentIqUrl + url, params).pipe(map(data => {
      return this.httpResponseHandlerService.handleHTTPResponse(data);
    }
    ), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }

  paymentIQDelete(url, params, urlParams, userId): Observable<String> {
    return this.http.delete(environment.paymentIqUrl + url + environment.paymentIqMID + "/" + userId +"/"+ urlParams, { params }).pipe(map(data => {
      return this.httpResponseHandlerService.handleHTTPResponse(data);
    }
    ), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }
  paymentIQDeleteSavedCards(url, userId, accountd,sessionId): Observable<String> {
    return this.http.delete(environment.paymentIqUrl + url  + environment.paymentIqMID +'/' +userId+'/'+accountd+'?sessionId='+sessionId ).pipe(map(data => {
      return this.httpResponseHandlerService.handleHTTPResponse(data);
    }
    ), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }

  paymentIQGet(searchParams, url, userId): Observable<String> {
    return this.http.get(environment.paymentIqUrl + url + environment.paymentIqMID + "/" + userId, { params: searchParams }).pipe(map(data => {
      return this.httpResponseHandlerService.handleHTTPResponse(data);
    }
    ), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }
  paymentIQGetTransaction(searchParams, url, userId, transactionId): Observable<String> {
    return this.http.get(environment.paymentIqUrl + url + environment.paymentIqMID + "/" + userId+'/'+transactionId+'/status', { params: searchParams }).pipe(map(data => {
      return this.httpResponseHandlerService.handleHTTPResponse(data);
    }
    ), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }
  getUrlParams(fields): HttpParams {
    let urlParams = new HttpParams();
    _.each(fields, function (value, key) {
      urlParams = urlParams.append(key,value);
    });
    return urlParams;
  }
  getCashierData(type) {
    if(type === "withdrawal"){
      type="cashout";
    }
    return this.get('', '/ajax/cashier/getCashierDetails?txnType='+type);
  }
  getAvailablePaymentMethodLimits() {
    return this.get('', "/ajax/cashier/getAvailablePaymentMethodsLimits");
  }
  getPendingWithdrawls() {
    return this.get('', '/ajax/cashier/getCashierData');
  }
  makePayment(depositObject: any) {
    return this.post(depositObject.paymentMethod === 'CREDITCARD' ? '/ajax/cashier/makeCCPayment' : '/ajax/cashier/makeWalletPayment', this.getUrlParams(depositObject));
  }
  getTransactionStatus(txnDetails: any) {
    return this.post('/ajax/cashier/gettransationStatus', this.getUrlParams(txnDetails));
  }
  getDepositLimit() {
    return this.get('', '/ajax/balance/getDepositLimit');
  }
  isBlockedCountry() {
    return this.get('', '/ajax/country/countryBlock');
  }
  checkUserProfile() {
    return this.post('/ajax/profile/checkUserProfile', "");
  }
  getChannelVerificationStatus(channelObject?) {
    return this.post('/ajax/cashier/channelVerificationStatus', this.getUrlParams(channelObject));
  }
  resendEmailVerification(credentials) {
    return this.post('/ajax/registration/sendChannelVeification', this.getUrlParams(credentials));
  }
  /*For PNP select Account -from withdrawal*/
  selectAccount(){
    return this.get('','/ajax/cashier/selectAccount');
  }
  processDeposit(paymentDetails) {
    return this.post('/ajax/cashier/processDepositPayvision', this.getUrlParams(paymentDetails));
  }
  initPNPDeposit(paymentDetails){
    return this.post('/ajax/payAndPlayTrustly/initPNPDeposit',this.getUrlParams(paymentDetails));
  }
  getPNPUserFromTransaction(payload){
    return this.get(payload,"/ajax/payAndPlayTrustly/getPNPUserFromTransaction");
  }
  getUserPendingTransaction(pendingMethodData,userId){
    return this.paymentIQGet(this.getUrlParams(pendingMethodData),"/api/user/transaction/",userId);
  }
  /*API for getting the token, needed to be passed for getting PaymentIQ payment methods*/
  getTokenPaymentIQ(token) {
    return this.get('', '/ajax/token/getToken?token=cashier');
  }
  /*API for getting all payment methods of PaymentIQ*/
  getPaymentIQmethods(credentials, playerID) {
    return this.paymentIQGet(credentials, "/api/user/payment/method/", playerID);
    /*Below code is for getting the response from JSON*/
    /* return this.http.get('../../../assets/paymentIQpaymentmethods.json').map(data=> {
         let response = data.json();
         return response;
     });*/
  }
  /*API for initiating deposit of PaymentIQ*/
  makePaymentPaymentIQ(depositObject: any, locale: string) {
    let paymentMethod = depositObject["paymentMethod"].split("-")[0];
    delete depositObject.paymentMethod;
    return this.paymentIQPost("/api/" + paymentMethod.toLowerCase() + "/deposit/process?locale="+locale, depositObject);
  }
  /*API for get transaction status of PaymentIQ*/
  getTransactionStatusPaymentIQ(userId, token) {
    return this.paymentIQGet({ "sessionId": token }, "/api/user/transaction/", userId);
  }
  getTransactionIdStatusPaymentIQ(userId, token, transactionID) {
    return this.paymentIQGetTransaction({ "sessionId": token }, "/api/user/transaction/", userId,transactionID);
  }

  getpaymentIQPendingWithdrawal(userId, token){
    return this.paymentIQGet({ "sessionId": token, "method": "Withdrawal", states: "WAITING_APPROVAL"}, "/api/user/transaction/", userId);
  }
  cancelpaymentIQPendingWithdrawal(txnId,userId,token){
    return this.paymentIQDelete("/api/user/transaction/",{ "sessionId": token}, txnId,userId);
  }
  deleteSavedCardPaymentIQ(userId,accountId,sessionId){
    return this.paymentIQDeleteSavedCards("/api/user/account/", userId,accountId,sessionId);
  }
  /*----------------------------------------------------WITHDRAW--------------------------------------------------------------------------*/
  getProfileBalanceCurrency() {
    return this.get('', '/ajax/profile/getProfileBalanceCurrency');
  }
  getProfileData(){
    return this.get('','/ajax/profile/getData');
  }

  makewithdraw(paymentDetails){
    return this.post(paymentDetails.paymentMethod === "CREDITCARD" ? '/ajax/cashier/makeCCWithdrawal' : '/ajax/cashier/makeWalletWithdrawal',this.getUrlParams(paymentDetails));
  }

  getStates(country){
    return this.get('/ajax/profile/getStateDetails',this.getUrlParams(country));
  }
  getCountries(): Observable<any>{
    return this.get('','/ajax/profile/getCountryDetails');
  }
  /*API for initiating deposit of PaymentIQ*/
  makeWithdrawalPaymentIQ(withdrawObject: any) {
    let paymentMethod = withdrawObject["paymentMethod"].split("_")[0];
    delete withdrawObject.paymentMethod;
    return this.paymentIQPost("/api/" + paymentMethod.toLowerCase() + "/withdrawal/process", withdrawObject);
  }

  getPaymentsMethods(){
    return this.get('',"/ajax/cashier/applicablePaymentMethodsForUser");
  }
  getCashierAmountConfig(type,currency){
    return this.get('',"/ajax/cashier/getCashierAmountsConfig?payment_type="+type+"&currency_iso_code="+currency);
  }

  depositeProcess(data){
    return this.post("/ajax/cashier/makeWalletPayment",this.getUrlParams(data));
  }
}
